<template>
    <cic-popup
        :title="item.templateId ? 'Edit Licence Template' : 'New Licence Template'"
        :saveable="editing"
        class="no-padding"
        @blur="$emit('blur')"
        @input="$emit('input')"
    >
        <ul style="padding: 10px 10px 10px 26px">
            <li class="form-label-first">
                {{ $t('Name') }}
            </li>
            <li>
                <cic-textbox
                    id="template_name"
                    :enabled="editing"
                    :value="item.name"
                    :maxlength="64"
                    @input="(val) => updateFieldValue('name', val)"
                />
            </li>
        </ul>
        <table id="tblLicences" class="cic-table">
            <thead>
                <tr>
                    <th>{{ $t('Licence') }}</th>
                    <th>{{ $t('Dependent Licence') }}</th>
                    <th style="width: 90px">{{ $t('Assigned') }}</th>
                </tr>
            </thead>
            <tbody>
                <template v-for="group in groups">
                    <tr>
                        <td class="primary" colspan="3">{{ group }}</td>
                    </tr>
                    <tr v-for="quantity in quantities.filter((x) => x.group === group)">
                        <td>{{ quantity.name }}</td>
                        <td>
                            <span v-if="quantity.required.length === 0">-</span>
                            <ul v-else>
                                <li
                                    v-for="required in quantities.filter((x) =>
                                        quantity.required.includes(x.quantityId),
                                    )"
                                >
                                    {{ required.name }}
                                </li>
                            </ul>
                        </td>
                        <td>
                            <cic-checkbox
                                :value="item.quantities.includes(quantity.quantityId)"
                                @input="(val) => handleClick(quantity.quantityId, val)"
                            />
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
    </cic-popup>
</template>

<script>
    import CicPopup from '@/components/CicPopup';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import CicTextbox from '@/components/inputs/CicTextbox';
    import { deselect, getGroups, select } from '../LicenceUtils';

    export default {
        name: 'EditLicenceTemplate',
        components: {
            CicCheckbox,
            CicPopup,
            CicTextbox,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
            quantities: {
                type: Array,
                required: true,
            },
        },
        emits: ['blur', 'input', 'updateFieldValue'],
        data() {
            return {
                editing: true,
                groups: [],
            };
        },
        created() {
            this.groups = getGroups(this.quantities);
        },
        methods: {
            handleClick(quantityId, val) {
                if (val) {
                    this.updateFieldValue(
                        'quantities',
                        select(
                            this.quantities,
                            this.item.quantities,
                            quantityId,
                            this.$t('TEMPLATE_SELECT_PARENTS'),
                            true,
                        ),
                    );
                } else {
                    this.updateFieldValue(
                        'quantities',
                        deselect(
                            this.quantities,
                            this.item.quantities,
                            quantityId,
                            this.$t('TEMPLATE_DESELECT_CHILDREN'),
                            true,
                        ),
                    );
                }
            },

            updateFieldValue(field, val) {
                this.$emit('updateFieldValue', field, val);
            },
        },
    };
</script>
